<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="ImagesAdd">
      <Icon name="plus" /> {{ $t('upload') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column
          v-for="(column, index) in columns"
          :key="index"
          :lg="4"
          :md="6"
          :xl="3">
          <RecordImage
            v-for="image in column"
            :key="image.id"
            :image="image" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordImage from './components/RecordImage'
import Table from '@mixins/Table'
import { getters } from '@utils'

export default {
  mixins: [Table],
  components: { RecordImage },
  data() {
    const { authUser, hasRole } = this.$store.getters
    return {
      paginationOptions: {
        name: 'adminImage',
        service: 'file',
        customQuery: hasRole('>=ADMIN')
          ? {}
          : { userId: authUser.id },
        searchIn: [
          'name',
        ],
        filters: [
          {
            label: 'Name',
            append: ['name', '$ilike'],
          },
          {
            label: 'type',
            append: ['type', '$eq'],
          },
          {
            label: 'Created since',
            type: 'date',
            append: ['createdAt', '$gte'],
          },
          {
            label: 'Created before',
            type: 'date',
            append: ['createdAt', '$lte'],
          },
        ],
        perPage: 12,
      },
    }
  },
  computed: {
    columns() {
      return this.splitIntoColumns(this.results, {
        xl: 4,
        lg: 3,
        md: 2,
        xs: 1,
      })
    },
    ...getters('splitIntoColumns'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "all": "All",
    "button": "Add a image",
    "title": "Images",
    "type": "type",
    "upload": "Upload"
  }
}
</i18n>
